import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["itemsContainer", "item", "suggestionCard"];

  addItem(event) {
    const template = document
      .getElementById("knowledge-base-item-template")
      .content.cloneNode(true);

    const newIndex = this.itemsContainerTarget.children.length;
    const newFields = template.querySelectorAll("[name]");

    newFields.forEach((field) => {
      field.name = field.name.replace("[]", `[${newIndex}]`);
    });

    this.itemsContainerTarget.appendChild(template);
  }

  addItemWithQuestion(event) {
    const suggestedQuestion = event.currentTarget.dataset.question;

    const template = document
      .getElementById("knowledge-base-item-template")
      .content.cloneNode(true);

    // Count existing items (each item is wrapped in a .contents div)
    const existingItems = this.itemTargets.length;
    const newIndex = existingItems;

    const newFields = template.querySelectorAll("[name]");

    newFields.forEach((field) => {
      field.name = field.name.replace("[]", `[${newIndex}]`);

      // Pre-fill the question field with the suggested question
      if (field.name.includes("[question]")) {
        field.value = suggestedQuestion;
      }
    });

    // Insert at the beginning of the container
    this.itemsContainerTarget.insertBefore(template, this.itemsContainerTarget.firstChild);

    // Find the newly added card and scroll to it
    const newCard = this.itemsContainerTarget.querySelector(".border.border-gray-200");
    if (newCard) {
      newCard.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });

      // Focus on the answer field since question is pre-filled
      const answerField = newCard.querySelector("[name*='[answer]']");
      if (answerField) {
        setTimeout(() => answerField.focus(), 300);
      }
    }
  }

  applySuggestion(event) {
    const button = event.currentTarget;
    const { itemIndex, fieldName, suggestedValue } = button.dataset;

    // Find the input/textarea for this item and field
    const fieldSelector = `[name="support_agent_knowledge_base[knowledge_base_items_attributes][${itemIndex}][${fieldName}]"]`;
    const field = document.querySelector(fieldSelector);

    if (field) {
      field.value = suggestedValue;

      // Add a brief visual feedback to the field
      field.classList.add("ring-2", "ring-green-500");
      setTimeout(() => {
        field.classList.remove("ring-2", "ring-green-500");
      }, 1000);

      // Gray out the suggestion card and add "Accepted" text
      const suggestionCard = button.closest(
        "[data-support-agent--knowledge-base-items-field-target='suggestionCard']"
      );
      if (suggestionCard) {
        suggestionCard.classList.add("opacity-50", "bg-gray-50");
        button.disabled = true;
        button.classList.add("cursor-not-allowed");

        // Add "Accepted" text
        const textContainer = suggestionCard.querySelector(".text-gray-700");
        if (textContainer && !textContainer.querySelector(".accepted-text")) {
          const acceptedSpan = document.createElement("span");
          acceptedSpan.className = "accepted-text ml-2 text-green-600 font-semibold text-xs";
          acceptedSpan.textContent = "(Accepted)";
          textContainer.appendChild(acceptedSpan);
        }
      }
    }
  }

  removeItem(event) {
    const item = event.target.closest(
      "[data-support-agent--knowledge-base-items-field-target='item']"
    );

    // If the item has an ID, mark it for destruction instead of removing it from the DOM immediately
    const hiddenDestroyField = item.querySelector("[name*='[_destroy]']");
    if (hiddenDestroyField) {
      hiddenDestroyField.value = "1";
      item.style.display = "none"; // Hide instead of removing immediately
    } else {
      item.remove();
    }
  }
}
